
  import { nextTick } from 'vue';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
  
  @Component
  export default class Multiselect extends Vue {
    @Prop({ default: () => [] }) readonly options!: Array<any>;
    @Prop({ default: 'name' }) readonly optionLabel!: string;
    @Prop({ default: '' }) readonly placeholder!: string;
    @Prop({ default: 1 }) readonly maxSelectedLabels!: number;
  @Prop({ default: false }) readonly selectAllInitially!: boolean;
  
    filterText: string = '';
    showDropdown: boolean = false;
    selectedOptions: Array<any> = [];
    filteredOptions: any;
  
    async mounted() {
      document.addEventListener('click', this.handleClickOutside);
      if (this.selectAllInitially) {
        await nextTick();
        this.selectAllOptions();
      }
    }
  
    @Watch("options", { immediate: true })
    onOptionsChange() {
      this.filteredOptions = this.options;
    }

    @Watch("selectAllInitially", { immediate: true })
    async onselectAllInitiallyChange() {
      if (this.selectAllInitially) {
        await nextTick();
        this.selectAllOptions();
      }
      else {
        this.$emit('input', this.selectedOptions);
      }
    }
  
    beforeDestroy() {
      document.removeEventListener('click', this.handleClickOutside);
    }
  
    get isAllSelected() {
      return this.selectedOptions.length === this.options.length;
    }
  
    get visibleSelectedOptions() {
      // Return the options up to the maxSelectedLabels limit
      return this.selectedOptions.slice(0, this.maxSelectedLabels);
    }
  
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    }
  
    handleClickOutside(event: MouseEvent) {
      const multiselect = this.$refs.multiselect as HTMLElement;
      if (multiselect && !multiselect.contains(event.target as Node)) {
        this.showDropdown = false;
      }
    }
  
    filterOptions() {
      const searchText = this.filterText.toLowerCase();
      this.filteredOptions = this.options.filter(option =>
        option[this.optionLabel].toLowerCase().includes(searchText)
      );
    }
  
    selectOption(option: any) {
      const index = option.departmentId
        ? this.selectedOptions.findIndex(opt => opt.departmentId === option.departmentId)
        : this.selectedOptions.indexOf(option);
      if (index > -1) {
        this.selectedOptions.splice(index, 1); // Remove option if already selected
      } else {
        this.selectedOptions.push(option); // Add option if not selected
      }
      this.$emit('input', this.selectedOptions); // Emit 'input' for v-model
    }
  
    get isSelected() {
      return (option: any) => {
        if (option.departmentId) {
          return this.selectedOptions.some(opt => {
            return opt.departmentId == option.departmentId;
          });
        }
        return this.selectedOptions.includes(option);
      }
    }
  
    toggleSelectAll() {
      if (this.isAllSelected) {
        this.selectedOptions = [];
      } else {
        this.selectedOptions = [...this.options];
      }
      this.$emit('input', this.selectedOptions); // Emit 'input' for v-model
    }

    selectAllOptions() {
      this.selectedOptions = [...this.options];
      this.$emit('input', this.selectedOptions); // Emit 'input' for v-model
    }
  
    clearSelection() {
      this.selectedOptions = [];
      this.$emit('input', this.selectedOptions); // Emit 'input' for v-model
    }
  }
  